import React, { useEffect, useRef, useState } from 'react';

export const useAccordion = (initialOpenState = false) => {
  const [isActive, setIsActive] = useState(initialOpenState);

  const contentRef = useRef(null);

  useEffect(() => {
    let timeoutId = null;
    if (isActive) {
      contentRef.current.style.height = contentRef.current.scrollHeight + 'px';
      contentRef.current.style.transition = 'height 0.25s ease-in-out';

      timeoutId = setTimeout(() => {
        // Reset height to auto after transition to allow for dynamic content changes
        if (contentRef?.current?.style) {
          contentRef.current.style.height = 'auto';
        }
      }, 250); // Match the transition duration
    } else {
      if (contentRef.current.offsetHeight !== 0) {
        contentRef.current.style.height = contentRef.current.scrollHeight + 'px'; // Set to current height to animate collapse
        timeoutId = setTimeout(() => {
          contentRef.current.style.height = 0
        }, 100);
      }
    }

    return () => {
      clearTimeout(timeoutId);
    };

  }, [isActive]);

  return {
    isActive,
    toggleAccordionState: () => setIsActive(prevState => !prevState),
    contentRef,
  };
}